import HttpClient from "./HttpClient";

class Resource {
  route;
  httpClient;

  constructor(route) {
    this.httpClient = HttpClient;
    this.route = route;
  }

  get(id, params) {
    let url;
    if (this.route.indexOf(":id") !== -1) {
      url = this.route.replace("/:id/", "/" + id + "/");
    } else {
      url = this.route + id;
    }

    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf("/:" + key + "/") !== -1) {
          url = url.replace("/:" + key + "/", "/" + params[key] + "/");
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig = {
      params: queryParams
    };

    return this.httpClient.get(url, requestConfig);
  }

  index(params) {
    let url = this.route;
    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf("/:" + key + "/") !== -1) {
          url = url.replace("/:" + key + "/", "/" + params[key] + "/");
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig = {
      params: queryParams
    };

    return this.httpClient.get(url, requestConfig);
  }

  create(payload) {
    return this.httpClient.post(this.route, payload).catch(errorResponse => {
      throw errorResponse;
    });
  }
}

export default Resource;



// WEBPACK FOOTER //
// ./src/services/api-client/resource/base/Resource.jsx